import { URL_CONSTANTS } from "../_constants";
import { ServiceHelper } from "./ServiceHelper";

export const AvantioService = {
    listAccommodations,
}

function listAccommodations(integrationUID: string) {
    return ServiceHelper.getRequest(
        URL_CONSTANTS.INTEGRATION_AVANTIO_ACCOMMODATIONS,
        {
            uid: integrationUID,
        }
    );
}
